export default {
  'zh-HK': {
    '邀请返现': '邀請返現',
    '限时活动': '限時活動',
    '活动暂未开放': '活動暫未開放',
    '活动尚未开始': '活動尚未開始',
    '活动配置加载失败': '活動配置載入失敗',
    '距活动开始': '距活動開始',
    '至': '至',
    '北京时间': '北京時間',
    '2026年10月22日 00:00 至 2026年11月21日 23:59（北京时间）': '2026年10月22日 00:00 至 2026年11月21日 23:59（北京時間）',
    '邀新购卡': '邀新購卡',
    '等额返现': '等額返現',
    '所有用户均可参与，不限邀请人数，邀请越多，返现越多。': '所有用戶均可參與，不限邀請人數，邀請越多，返現越多。',
    '距活动结束': '距活動結束',
    '活动已结束': '活動已結束',
    '立即邀请好友': '立即邀請好友',
    '查看活动规则': '查看活動規則',
    '好友首次购卡': '好友首次購卡',
    '你获得返现': '你獲得返現',
    '如何获得返现': '如何獲得返現',
    '分享邀请': '分享邀請',
    '好友注册': '好友註冊',
    '首购点卡': '首購點卡',
    '返现到账': '返現到賬',
    '返现规则': '返現規則',
    '邀请新用户注册，新用户首次购买点卡后，等额现金会直接返到你的返佣账户，可以提现。': '邀請新用戶註冊，新用戶首次購買點卡後，等額現金會直接返到你的返傭賬戶，可以提現。',
    '新用户首次购买点卡': '新用戶首次購買點卡',
    '新用户指活动期间通过你的邀请注册的用户。': '新用戶指活動期間透過你的邀請註冊的用戶。',
    '每位新用户只返一次，按其注册后第一笔点卡订单的面额计算。': '每位新用戶只返一次，按其註冊後第一筆點卡訂單的面額計算。',
    '第一笔订单不是 50 U 或 100 U 点卡的，不返现，之后的订单也不再补返。': '第一筆訂單不是 50 U 或 100 U 點卡的，不返現，之後的訂單也不再補返。',
    '第一笔订单面额不在活动档位内的，不返现，之后的订单也不再补返。': '第一筆訂單面額不在活動檔位內的，不返現，之後的訂單也不再補返。',
    '只奖励直接邀请人，不向更上一级发放。': '只獎勵直接邀請人，不向更上一級發放。',
    '返现发放': '返現發放',
    '新用户订单支付成功后，返现立即进入你的返佣账户。': '新用戶訂單支付成功後，返現立即進入你的返傭賬戶。',
    '返佣账户的余额可以提现，提现规则以 App 内公示为准。': '返傭賬戶的餘額可以提現，提現規則以 App 內公示為準。',
    '其他说明': '其他説明',
    '活动开始前已注册的用户不算新用户。': '活動開始前已註冊的用戶不算新用戶。',
    '新用户首次购买须在活动期间完成。': '新用戶首次購買須在活動期間完成。',
    '本活动最终解释权归平台所有。': '本活動最終解釋權歸平台所有。',
    '我的邀请': '我的邀請',
    '返佣账户 · 去提现': '返傭賬戶 · 去提現',
    '已邀请新用户': '已邀請新用戶',
    '累计返现': '累計返現',
    '我的邀请码': '我的邀請碼',
    '复制链接': '複製連結',
    '邀请记录': '邀請記錄',
    '全部': '全部',
    '已注册，待首购': '已註冊，待首購',
    '已返现': '已返現',
    '待首购': '待首購',
    '不符合条件': '不符合條件',
    '活动已关闭': '活動已關閉',
    '不在活动有效期内': '不在活動有效期內',
    '非活动期内新注册用户': '非活動期內新註冊用戶',
    '无有效注册邀请关系': '無有效註冊邀請關係',
    '首单面额不在活动档位内': '首單面額不在活動檔位內',
    '首单不符合返现条件': '首單不符合返現條件',
    '不符合活动条件': '不符合活動條件',
    '首购非 50/100 U 点卡': '首購非 50/100 U 點卡',
    '不返现': '不返現',
    '暂无邀请记录': '暫無邀請記錄',
    '邀请数据暂时无法读取，请稍后重试': '邀請數據暫時無法讀取，請稍後重試',
    '重新加载': '重新載入',
    '上一页': '上一頁',
    '下一页': '下一頁',
    '邀请码已复制': '邀請碼已複製',
    '邀请链接已复制': '邀請連結已複製',
    '好友': '好友',
    '注册时间': '註冊時間',
    '返现状态': '返現狀態',
    '返现金额': '返現金額',
    '到账时间': '到賬時間',
    '关闭邀请记录': '關閉邀請記錄',
    '人': '人',
    '天': '天',
    '时': '時',
    '分': '分',
    '秒': '秒',
    '复制失败，请稍后重试': '複製失敗，請稍後重試'
  },
  en: {
    '邀请返现': 'Invite & Earn',
    '限时活动': 'Limited-time event',
    '活动暂未开放': 'Event not available yet',
    '活动尚未开始': 'Event has not started',
    '活动配置加载失败': 'Failed to load event settings',
    '距活动开始': 'Starts in',
    '至': 'to',
    '北京时间': 'Beijing Time',
    '2026年10月22日 00:00 至 2026年11月21日 23:59（北京时间）': 'Oct 22, 2026 00:00 – Nov 21, 2026 23:59 (Beijing Time)',
    '邀新购卡': 'Invite friends to buy points',
    '等额返现': 'Get equal cashback',
    '所有用户均可参与，不限邀请人数，邀请越多，返现越多。': 'Open to all users. There is no invitation limit—the more you invite, the more you earn.',
    '距活动结束': 'Ends in',
    '活动已结束': 'Event ended',
    '立即邀请好友': 'Invite friends now',
    '查看活动规则': 'View event rules',
    '好友首次购卡': "Friend's first purchase",
    '你获得返现': 'Your cashback',
    '如何获得返现': 'How to earn cashback',
    '分享邀请': 'Share invitation',
    '好友注册': 'Friend registers',
    '首购点卡': 'First points purchase',
    '返现到账': 'Cashback credited',
    '返现规则': 'Cashback rules',
    '邀请新用户注册，新用户首次购买点卡后，等额现金会直接返到你的返佣账户，可以提现。': "Invite a new user. After their first points purchase, an equal cash amount is credited to your commission account and can be withdrawn.",
    '新用户首次购买点卡': "New user's first points purchase",
    '新用户指活动期间通过你的邀请注册的用户。': 'A new user is someone who registers through your invitation during the event.',
    '每位新用户只返一次，按其注册后第一笔点卡订单的面额计算。': 'Each new user qualifies once, based on the value of their first points order after registration.',
    '第一笔订单不是 50 U 或 100 U 点卡的，不返现，之后的订单也不再补返。': 'If the first order is not a 50 U or 100 U points card, no cashback is paid and later orders do not qualify.',
    '第一笔订单面额不在活动档位内的，不返现，之后的订单也不再补返。': 'If the first order amount is not an eligible tier, no cashback is paid and later orders do not qualify.',
    '只奖励直接邀请人，不向更上一级发放。': 'Only the direct inviter is rewarded.',
    '返现发放': 'Cashback payment',
    '新用户订单支付成功后，返现立即进入你的返佣账户。': "After the new user's payment succeeds, cashback is credited to your commission account immediately.",
    '返佣账户的余额可以提现，提现规则以 App 内公示为准。': 'The commission balance can be withdrawn subject to the rules shown in the App.',
    '其他说明': 'Other notes',
    '活动开始前已注册的用户不算新用户。': 'Users registered before the event are not considered new users.',
    '新用户首次购买须在活动期间完成。': 'The new user must complete their first purchase during the event.',
    '本活动最终解释权归平台所有。': 'The platform reserves the final right of interpretation.',
    '我的邀请': 'My invitations',
    '返佣账户 · 去提现': 'Commission account · Withdraw',
    '已邀请新用户': 'New users invited',
    '累计返现': 'Total cashback',
    '我的邀请码': 'My invite code',
    '复制链接': 'Copy link',
    '邀请记录': 'Invitation records',
    '全部': 'All',
    '已注册，待首购': 'Registered, awaiting first purchase',
    '已返现': 'Cashback paid',
    '待首购': 'Awaiting first purchase',
    '不符合条件': 'Ineligible',
    '活动已关闭': 'Event closed',
    '不在活动有效期内': 'Outside the event period',
    '非活动期内新注册用户': 'Not registered during the event',
    '无有效注册邀请关系': 'No valid invitation relationship',
    '首单面额不在活动档位内': 'First purchase amount is not eligible',
    '首单不符合返现条件': 'First purchase is not eligible',
    '不符合活动条件': 'Does not meet event requirements',
    '首购非 50/100 U 点卡': 'First purchase was not a 50/100 U card',
    '不返现': 'No cashback',
    '暂无邀请记录': 'No invitation records yet',
    '邀请数据暂时无法读取，请稍后重试': 'Invitation data is temporarily unavailable. Please try again later.',
    '重新加载': 'Reload',
    '上一页': 'Previous',
    '下一页': 'Next',
    '邀请码已复制': 'Invite code copied',
    '邀请链接已复制': 'Invitation link copied',
    '好友': 'Friend',
    '注册时间': 'Registration time',
    '返现状态': 'Cashback status',
    '返现金额': 'Cashback amount',
    '到账时间': 'Credited at',
    '关闭邀请记录': 'Close invitation records',
    '人': 'people',
    '天': 'd',
    '时': 'h',
    '分': 'm',
    '秒': 's',
    '复制失败，请稍后重试': 'Copy failed. Please try again later.'
  },
  ko: {
    '邀请返现': '친구 초대 캐시백',
    '限时活动': '기간 한정 이벤트',
    '活动暂未开放': '이벤트 준비 중',
    '活动尚未开始': '이벤트 시작 전',
    '活动配置加载失败': '이벤트 설정을 불러오지 못했습니다',
    '距活动开始': '이벤트 시작까지',
    '至': '~',
    '北京时间': '베이징 시간',
    '2026年10月22日 00:00 至 2026年11月21日 23:59（北京时间）': '2026년 10월 22일 00:00 ~ 2026년 11월 21일 23:59 (베이징 시간)',
    '邀新购卡': '친구의 포인트 카드 구매',
    '等额返现': '동일 금액 캐시백',
    '所有用户均可参与，不限邀请人数，邀请越多，返现越多。': '모든 사용자가 참여할 수 있으며 초대 인원 제한이 없습니다. 더 많이 초대할수록 더 많은 캐시백을 받습니다.',
    '距活动结束': '이벤트 종료까지',
    '活动已结束': '이벤트 종료',
    '立即邀请好友': '지금 친구 초대',
    '查看活动规则': '이벤트 규칙 보기',
    '好友首次购卡': '친구의 첫 카드 구매',
    '你获得返现': '내 캐시백',
    '如何获得返现': '캐시백 받는 방법',
    '分享邀请': '초대 공유',
    '好友注册': '친구 가입',
    '首购点卡': '첫 포인트 카드 구매',
    '返现到账': '캐시백 지급',
    '返现规则': '캐시백 규칙',
    '邀请新用户注册，新用户首次购买点卡后，等额现金会直接返到你的返佣账户，可以提现。': '신규 사용자를 초대하면 첫 포인트 카드 구매 후 동일한 금액이 커미션 계정에 적립되며 출금할 수 있습니다.',
    '新用户首次购买点卡': '신규 사용자의 첫 포인트 카드 구매',
    '新用户指活动期间通过你的邀请注册的用户。': '신규 사용자는 이벤트 기간에 내 초대로 가입한 사용자입니다.',
    '每位新用户只返一次，按其注册后第一笔点卡订单的面额计算。': '신규 사용자 1명당 한 번만 지급되며 가입 후 첫 포인트 카드 주문 금액을 기준으로 합니다.',
    '第一笔订单不是 50 U 或 100 U 点卡的，不返现，之后的订单也不再补返。': '첫 주문이 50 U 또는 100 U 카드가 아니면 캐시백이 지급되지 않으며 이후 주문도 소급 적용되지 않습니다.',
    '第一笔订单面额不在活动档位内的，不返现，之后的订单也不再补返。': '첫 주문 금액이 이벤트 대상이 아니면 캐시백이 지급되지 않으며 이후 주문도 소급 적용되지 않습니다.',
    '只奖励直接邀请人，不向更上一级发放。': '직접 초대한 사용자에게만 지급됩니다.',
    '返现发放': '캐시백 지급',
    '新用户订单支付成功后，返现立即进入你的返佣账户。': '신규 사용자의 결제가 완료되면 캐시백이 커미션 계정에 즉시 적립됩니다.',
    '返佣账户的余额可以提现，提现规则以 App 内公示为准。': '커미션 계정 잔액은 출금할 수 있으며 출금 규칙은 App 안내를 따릅니다.',
    '其他说明': '기타 안내',
    '活动开始前已注册的用户不算新用户。': '이벤트 시작 전에 가입한 사용자는 신규 사용자로 인정되지 않습니다.',
    '新用户首次购买须在活动期间完成。': '신규 사용자의 첫 구매는 이벤트 기간에 완료되어야 합니다.',
    '本活动最终解释权归平台所有。': '본 이벤트의 최종 해석 권한은 플랫폼에 있습니다.',
    '我的邀请': '내 초대',
    '返佣账户 · 去提现': '커미션 계정 · 출금하기',
    '已邀请新用户': '초대한 신규 사용자',
    '累计返现': '누적 캐시백',
    '我的邀请码': '내 초대 코드',
    '复制链接': '링크 복사',
    '邀请记录': '초대 기록',
    '全部': '전체',
    '已注册，待首购': '가입 완료, 첫 구매 대기',
    '已返现': '캐시백 지급 완료',
    '待首购': '첫 구매 대기',
    '不符合条件': '조건 미충족',
    '活动已关闭': '이벤트 종료됨',
    '不在活动有效期内': '이벤트 기간 외',
    '非活动期内新注册用户': '이벤트 기간 신규 가입자가 아님',
    '无有效注册邀请关系': '유효한 초대 관계 없음',
    '首单面额不在活动档位内': '첫 구매 금액이 대상 아님',
    '首单不符合返现条件': '첫 구매가 캐시백 조건을 충족하지 않음',
    '不符合活动条件': '이벤트 조건 미충족',
    '首购非 50/100 U 点卡': '첫 구매가 50/100 U 카드가 아님',
    '不返现': '캐시백 없음',
    '暂无邀请记录': '초대 기록이 없습니다',
    '邀请数据暂时无法读取，请稍后重试': '초대 데이터를 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.',
    '重新加载': '다시 불러오기',
    '上一页': '이전',
    '下一页': '다음',
    '邀请码已复制': '초대 코드가 복사되었습니다',
    '邀请链接已复制': '초대 링크가 복사되었습니다',
    '好友': '친구',
    '注册时间': '가입 시간',
    '返现状态': '캐시백 상태',
    '返现金额': '캐시백 금액',
    '到账时间': '지급 시간',
    '关闭邀请记录': '초대 기록 닫기',
    '人': '명',
    '天': '일',
    '时': '시간',
    '分': '분',
    '秒': '초',
    '复制失败，请稍后重试': '복사하지 못했습니다. 잠시 후 다시 시도해 주세요.'
  }
}
